export function isNullOrUndefined(arg) {
    return arg == null;
}